import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

const BASEURL = environment.apiBase;

@Injectable({
  providedIn: 'root'
})
export class ReferralsService {

  constructor(
    private http: HttpClient
  ) { }

  public getReferrals(): Observable<any> {

    return this.http.get(`${BASEURL}/referrals`, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });
  }
}
